'use client'

import styles from './ShowPosterGrid.module.scss';

import { ShowDetails, ShowRowContent } from '@/lib/types/api/show-data';

import ShowPoster, { ShowBadgeFlags } from '@/components/ShowPoster/ShowPoster';
import { ShowNode } from '@/lib/types/graphql/searchShowsResponse';

export interface ShowPosterGridProps {
  shows: ShowDetails[] | ShowRowContent[] | ShowNode[]
  showBadgeFlags?: ShowBadgeFlags;
}

export default function ShowPosterGrid(props: ShowPosterGridProps) {
  const { shows, showBadgeFlags } = props

  return (
    <div className={styles.show_poster_grid}>
      {shows.map((show, i: number) => {
        return (
          <ShowPoster key={i} show={show} showBadgeFlags={showBadgeFlags} />
        )
      })}
    </div>
  )
}
